/**
 * Web sitesi bölümünün bütün ekran metni (07.10.2026, onaylı taslak A).
 *
 * Cümleler taslaktan (`web-sitesi-a-tam.html`) alındı; taslakta sabit yazılmış sayılar burada
 * işlev parametresi. `scripts/metin-tamlik.test.mjs` ekranı çizen dosyalarda gömülü metin
 * bırakmıyor, bu yüzden hiçbir cümle bileşende yazılmıyor.
 */

export const WS = {
  baslik: 'Web sitesi',
  odeme: {
    musteri: 'Müşteri adı', telefon: 'Telefon numarası', bilgiYok: '—',
    baslik: 'Ödeme denemeleri', aciklama: 'Ödeme bağlantıları ve sağlayıcıdan gelen son sonuçlar',
    kapsam: 'Her satır bir ödeme kaydıdır. Tarihler ödeme kaydının oluşturulma gününe göre süzülür (UTC); saatler BAE saatidir. Tarih seçilmezse son 30 gün gösterilir.',
    referans: 'Sipariş referansı', saglayici: 'Sağlayıcı', tutar: 'Tutar', tarih: 'Oluşturulma tarihi',
    durum: 'Ödeme durumu', siparis: 'Sipariş durumu', bildirim: 'Son bildirim',
    tarihAraligi: 'Tarih aralığı (UTC)', hepsi: 'Tümü', uygula: 'Uygula',
    basarisizlik: 'Başarısızlık bildirimi', onceki: 'Önceki', sonraki: 'Sonraki', bos: 'Bu süzgeçlerle ödeme kaydı bulunamadı.',
    hata: 'Ödeme kayıtları alınamadı. Yeniden deneyin.', yetki: 'Ödeme denemelerini görüntüleme yetkiniz yok.',
    siparisYetki: 'Sipariş ayrıntıları için yetki gerekir.',
    yok: 'Bildirim yok', bilinmeyen: 'Diğer sağlayıcı bildirimi', neden: 'Neden bildirilmedi?',
    nedenMetni: 'Bu ödeme için imzası doğrulanmış, kayıtla eşleşen bir sağlayıcı bildirimi henüz bulunmuyor. Ödeme bağlantısı oluşturulması tahsilat anlamına gelmez.',
    tamamlandi: 'Tamamlanma bildirimi; Bu bildirimle tahsilat doğrulanmadı', tahsilat: 'Tahsilat doğrulandı',
    onay: 'Yetkilendirme bildirimi', iade: 'İade bildirimi',
    durumlar: { CREATED: 'Ödeme bekliyor / bağlantı oluşturuldu', AUTHORIZED: 'Ödeme yetkilendirildi', CAPTURED: 'Tahsilat kaydı', FAILED: 'Başarısız ödeme kaydı', REFUNDED: 'İade edildi', VOIDED: 'Provizyon serbest bırakıldı' },
    siparisDurumlari: { PENDING_PAYMENT: 'Ödeme bekliyor', PAID: 'Ödendi', CANCELLED: 'İptal edildi', REFUNDED: 'İade edildi' },
    sayfa: (bas: number, son: number, toplam: number) => `${bas}–${son} / ${toplam} ödeme kaydı`,
  },
  sekmelerAria: 'Web sitesi sekmeleri',
  sekme: { genel: 'Genel bakış', talepler: 'Talepler', uyeler: 'Üyeler', siparisler: 'Siparişler', odemeler: 'Ödeme denemeleri' },
  tasindi: {
    satisBir: 'Satış raporu',
    ve: 've',
    satisIki: 'Katalog',
    satisSon: 'Satış bölümüne taşındı.',
    finans: 'Alacaklar ve faturalar',
    finansSon: 'Finans bölümüne taşındı.',
  },
  yukleniyor: 'Yükleniyor…',
  yenile: 'Yeniden dene',
  hata: 'Bu bölüm yüklenemedi.',
  olcum: (an: string) =>
    `Sayılar ${an} (BAE saati) ölçümüdür. Her sayı canlı kayıttan hesaplanır, ölçülemeyen değer için henüz ölçülmüyor yazılır. Hukuki dayanak: BAE PDPL.`,
  kesildi: 'Liste ilk 5.000 kaydı kapsıyor, gerisi hesaba girmedi.',
  vizeYetki: 'Vize başvurularını okuma yetkiniz yok, bu liste vizesiz gösteriliyor.',

  // --- tür adları ---
  tur: { destek: 'Destek', on: 'Ön talep', vize: 'Vize', sip: 'Sipariş' },
  sahip: { sende: 'Sende', musteri: 'Müşteride', kapali: 'Kapandı' },
  esikAsildi: (gun: number) => `${gun} günü geçti`,
  gunOnce: (gun: number) => `${gun} gün önce`,
  saat: (n: number) => `${n} saat`,
  gun: (n: number) => `${n} gün`,
  ziyaretci: 'Ziyaretçi',
  misafir: 'Misafir',
  tarihYok: 'tarih yok',
  baeSaati: 'BAE saati',

  // --- veri sağlığı şeridi ---
  saglik: {
    baslik: 'Veri sağlığı',
    ayrinti: 'Ayrıntı',
    gizle: 'Gizle',
    sistem: (n: number) => `${n} sistem uyarısı müşteri taleplerinden ayrı`,
    sistemAc: 'Sistem uyarılarını aç',
    spam: (n: number) => `${n} spam destek mesajı gizli`,
    spamAc: 'Spam mesajlarını aç',
    spamEtiket: 'Spam',
    siparis: (v3: number | null, crm: number) =>
      v3 === null ? `Sipariş: CRM'de ${crm}, sitedeki sayı okunamadı` : `Sipariş: sitede ${v3}, CRM'de ${crm}`,
    vize: (crm: number) => `Vize: CRM'de ${crm}, site tarafı henüz ölçülmüyor`,
    siparisBaslik: 'Sipariş',
    vizeBaslik: 'Vize başvurusu',
    destekBaslik: 'Destek mesajı',
    gorulmeBaslik: 'Son görülme',
    v3Etiket: 'Site',
    crmEtiket: 'CRM',
    gercekEtiket: 'Gerçek',
    sistemEtiket: 'Sistem',
    siparisFark: (n: number) => `${n} sipariş CRM'e düşmemiş.`,
    siparisEsit: 'İki taraf eşit.',
    siparisOkunamadi: 'Sitedeki sipariş sayısı okunamadı, fark ölçülemedi.',
    vizeNot: (crm: number) => `CRM'de ${crm} vize kaydı var. Sitedeki başvuru sayısı CRM'den okunamıyor, bu yüzden fark henüz ölçülmüyor.`,
    destekNot: (toplam: number, sistem: number, spam: number) =>
      `CRM'deki ${toplam} destek talebinin ${sistem} tanesi web sitesinin kendi sağlık yoklaması, ${spam} tanesi spam. Panel bunları müşteri talebi saymaz.`,
    gorulmeNot: (alinan: number, toplam: number, onay: number) =>
      `Son görülme siteden ${toplam} üyenin ${alinan} tanesi için geldi. Üyelik onayı ${toplam} üyenin ${onay} tanesinde dolu.`,
    gorulmeHic: 'Son görülme sitenin oturum kaydından gelir, henüz CRM\'e aktarılmadı.',
  },

  // --- kutular ---
  kutu: {
    uye: 'Yeni üye',
    destek: 'Destek mesajı',
    onVize: 'Ön talep ve vize',
    siparis: 'Sipariş',
    donen: 'Dönen üye',
    bugun: 'bugün',
    son7Birim: 'son 7 günde',
    karsilastir: (son: number, once: number) => `Son 7 günde ${son}, önceki 7 günde ${once}`,
    donenKarsilastir: (s30: number, toplam: number, hic: number) => `Son 30 günde ${s30} / ${toplam}, hiç oturumu olmayan ${hic}`,
    donenBilinmiyor: 'Henüz ölçülmüyor',
    donenBilinmiyorNot: 'Son görülme siteden gelmeye başlayınca burada görünür.',
    gunAria: (ad: string) => `${ad}, son 14 gün, gün gün`,
    kareAria: (toplam: number, s30: number, hic: number) => `${toplam} üye: ${s30} üye son 30 günde görüldü, ${hic} üyenin hiç oturumu yok`,
    kareIpucu: (ad: string, gun: number | null) => (gun === null ? `${ad}: hiç oturum yok` : `${ad}: ${Math.round(gun)} gün önce görüldü`),
    anahtarSon7: 'son 7 gün',
    anahtarOnceki7: 'önceki 7 gün',
    anahtarNot: 'Dönen üye karosu: dolu kare son 30 günde görülen, boş kare hiç oturumu olmayan.',
    tikla: 'Karolara, çubuklara ve noktalara tıklayınca ilgili sekme süzülmüş açılır.',
  },

  // --- özet çubuğu ---
  ozet: {
    bekliyor: (n: number) => `${n} iş bekliyor`,
    sende: (n: number) => `${n} sende`,
    musteride: (n: number) => `${n} müşteride (ödeme)`,
    asti: (n: number) => `${n} iş kendi eşiğini aştı`,
    esikler: (d: number, o: number, s: number, v: number) => `Eşikler: destek ${d}, ön talep ${o}, sipariş ${s}, vize ${v} gün`,
  },

  // --- grafik kartları ---
  yas: {
    baslik: 'Ne kadardır bekliyor?',
    alt: (n: number) => `${n} iş, her nokta bir iş. Kırmızı bölge o türün eşiği. Noktaya tıklayın.`,
    icinde: 'Eşik içinde',
    asti: 'Eşiği aştı',
    aria: (n: number) => `Bekleme yaşı: her açık iş bir nokta. ${n} iş kendi eşiğini aştı.`,
    ustu: (gun: number) => `${gun} gün üstü`,
    is: (n: number) => `${n} iş`,
    ipucu: (ref: string, gun: string, esik: number, asti: boolean, sende: boolean) =>
      `${ref}\nbekliyor: ${gun} gün${asti ? ` (eşik ${esik} gün, aşıldı)` : ` (eşik ${esik} gün)`}\nkimde: ${sende ? 'sende' : 'müşteride'}`,
    noktaAria: (ref: string, gun: string) => `${ref}, ${gun} gün bekliyor`,
    gunKisa: (n: number) => `${n} g`,
    gunMetni: (n: string) => `${n} gün`,
    tabloIs: 'İş',
    tabloTur: 'Tür',
    tabloBekleme: 'Bekleme',
    tabloKimde: 'Kimde',
    esikAsildi: (gun: number) => ` (eşik ${gun} gün, aşıldı)`,
  },
  asama: {
    baslik: 'Nerede sıkışıyor?',
    alt: 'Kaynak başına aşamalar, ortak ölçek. Satıra tıklayınca liste açılır.',
    ipucu: (baslik: string, etiket: string, n: number) => `${baslik}, ${etiket}: ${n} iş. Tıklayınca listeyi açar`,
    aria: (baslik: string, satirlar: string) => `${baslik}: ${satirlar}`,
    tabloKaynak: 'Kaynak',
    tabloAsama: 'Aşama',
    tabloIs: 'İş',
  },
  donusum: {
    baslik: 'Ne dönüştü?',
    alt: 'Üyelikten ödemeye.',
    odenenEtiket: 'ödenen sipariş',
    notu: 'Çubuklar iç içe değil: sipariş verenlerin hepsi üye olmayabilir.',
    aria: (satirlar: string) => `Dönüşüm: ${satirlar}`,
    ipucu: (etiket: string, n: number) => `${etiket}: ${n}. Tıklayınca listeyi açar`,
    tabloAsama: 'Aşama',
    tabloKisi: 'Kişi',
  },
  risk: {
    baslik: 'Kim kayboluyor?',
    alt: (n: number) => `Son görülmeden beri geçen gün, ${n} üye.`,
    dogrulanmis: 'E-postası doğrulanmış',
    dogrulanmamis: 'Doğrulanmamış',
    otuzGecti: '30 günü geçti',
    otuzKisa: '30 g+',
    gun7: '7 gün',
    hicOturum: (n: number) => `Hiç oturum açmadı (${n})`,
    hicNot: (gun: number) => `kayıttan beri giriş yok, kayıt ${gun} gün önce`,
    ipucuGorulen: (ad: string, gun: number, dogrulanmis: boolean) => `${ad}\nson görülme: ${gun} gün önce\ne-posta ${dogrulanmis ? 'doğrulanmış' : 'doğrulanmamış'}`,
    ipucuHic: (ad: string) => `${ad}\nhiç oturum açmadı`,
    aria: (toplam: number, gorulen: number, hic: number) => `Kayıp riski: ${toplam} üye. ${gorulen} üyenin son görülmesi gün olarak çizildi, ${hic} üyenin hiç oturumu yok.`,
    daha: (n: number) => `ve ${n} üye daha, Üyeler sekmesinde.`,
    bilinmiyor: 'Henüz ölçülmüyor',
    bilinmiyorNot: 'Son görülme siteden gelmeye başlayınca burada görünür.',
    tabloUye: 'Üye',
    tabloGorulme: 'Son görülme',
    tabloEposta: 'E-posta',
    tabloKayit: 'Kayıt',
    hicOturumYok: 'hiç oturum yok',
    dogrulanmisKucuk: 'doğrulanmış',
    dogrulanmamisKucuk: 'doğrulanmamış',
  },
  tablo: 'Tablo görünümü',
  grafik: 'Grafik görünümü',
  olcumYok: {
    ayrac: 'ölçüm eklenince burada görünür',
    src: ['Kaynak kanalı', 'Henüz ölçülmüyor. Siteden gelen her kayıt web görünüyor.'],
    ulke: ['Ülke dağılımı', 'Henüz ölçülmüyor. Üyede ve talepte ülke alanı yok.'],
    yanit: ['İlk yanıt süresi', 'Henüz ölçülmüyor. CRM yanıt zamanı yazmıyor.'],
    zi: ['Ziyaretçiden üyeye', 'Henüz ölçülmüyor. Ziyaretçi sayısı CRM\'de yok.'],
    ts: ['Talepten siparişe', 'Henüz ölçülmüyor. Talep ile sipariş arasında bağ alanı yok.'],
  },
  enUzun: {
    baslik: 'En uzun bekleyen beş iş',
    alt: 'Satıra tıklayınca kişi çekmecesi açılır.',
    tumu: (n: number) => `Tüm talepleri aç (${n})`,
    kim: 'Kim',
    ne: 'Ne',
    tur: 'Tür',
    bekleme: 'Bekleme',
  },

  // --- arama ve süzgeç (hepsi tek kutu) ---
  ara: {
    talep: 'Ara: ad, e-posta, telefon, referans, tutar, tarih',
    uye: 'Ara: ad, e-posta, telefon, tarih',
    siparis: 'Ara: referans, ad, ürün, tutar, tarih',
    aria: 'Bu listede ara',
    ipucu: 'Büyük ve küçük harf, Türkçe harf ve aksan fark etmez. Telefonda boşluk ve işaretler yok sayılır. Tarih: 07.10, 2026-10-07, ekim.',
    eslesti: 'Eşleşen alan',
    tarihAralik: 'Tarih aralığı',
    aralikBos: 'Tarih aralığı seçin',
    aralikYari: 'Bitiş tarihini seçin',
    aralikTemizle: 'Aralığı temizle',
    sonucYok: 'Aramaya uyan kayıt yok.',
  },
  alan: {
    ad: 'ad',
    eposta: 'e-posta',
    kimlik: 'kimlik',
    musteri: 'müşteri kaydı',
    telefon: 'telefon',
    uyelik: 'üyelik tarihi',
    sonGorulme: 'son görülme',
    referans: 'referans',
    ne: 'özet',
    konu: 'konu',
    siparis: 'sipariş',
    tur: 'tür',
    tarih: 'tarih',
    tutar: 'tutar',
    urun: 'ürün',
    verildi: 'verilme tarihi',
  },

  // --- talepler ---
  talepler: {
    baslik: 'Talepler',
    alt: 'Destek mesajı, ön talep ve vize başvurusu tek kuyrukta. Satıra tıklayınca kişi çekmecesi açılır.',
    adet: (n: number) => `${n} iş`,
    turEtiket: 'Tür',
    tumu: 'Tümü',
    onVize: 'Ön talep ve vize',
    sistem: 'Sistem',
    sistemAlt: 'Web sitesinin kendi sağlık yoklamaları. Müşteri talebi değil, hiçbir kayıt silinmedi.',
    spam: 'Spam',
    spamAlt: 'Kurallara göre spam sayılan destek mesajları. Hiçbiri silinmedi; yanlış sayılmışsa satırı açıp Spam değil de.',
    spamBos: ['Spam mesajı yok', 'Spam sayılan bir destek mesajı bulunmuyor.'],
    suphe: (n: number) => `${n} şüpheli mesaj etiketli, listede duruyor.`,
    esigiAsanlar: 'Eşiği aşanlar',
    durumAria: 'Durum',
    sirala: 'Sırala',
    enUzun: 'En uzun bekleyen önce',
    enYeni: 'En yeni önce',
    kim: 'Kim',
    ne: 'Ne',
    tur: 'Tür',
    bekleme: 'Bekleme',
    esik: 'Eşik',
    sonraki: 'Sonraki adım',
    esikGun: (n: number) => `${n} gün`,
    kapaliBos: ['Kapanan talep yok', 'Henüz hiçbir talep kapatılmadı. Kapatılan işler burada listelenir.'],
    musteriBos: ['Müşteride bekleyen talep yok', 'Ödeme bekleyen siparişler Siparişler sekmesinde.'],
    musteriBosDugme: 'Siparişlerde aç',
    suzgecBos: ['Bu süzgeçte iş yok', 'Tür seçimini, aramayı, tarih aralığını ya da eşik süzgecini temizleyin.'],
    not: (d: number, o: number, v: number, s: number, gizli: number, spam: number) =>
      `Gecikme eşikleri: destek ${d} gün, ön talep ${o} gün, vize ${v} gün. Sipariş eşiği ${s} gün ve Siparişler sekmesinde. Sistem uyarıları (${gizli}) ve spam (${spam}) müşteri talebi sayılmaz, kendi süzgeçlerinde.`,
    sinifEtiket: { SUPHELI: 'Şüpheli', SPAM: 'Spam' },
    daha: 'Daha fazla göster',
  },

  // --- üyeler ---
  uyeler: {
    baslik: 'Üyeler',
    alt: (n: number) => `Siteden üye olan ${n} kişi. Satıra tıklayınca kişi sayfası açılır.`,
    adet: (n: number) => `${n} üye`,
    hepsi: 'Tümü',
    dogrulanmamis: 'E-postası doğrulanmamış',
    dogrulanmis: 'Doğrulanmış',
    oturumsuz: 'Hiç oturumu yok',
    siparisli: 'Siparişi olan',
    kayipOdemeli: (gun: number) => `Ödeme bekleyen, ${gun} günden uzun görülmemiş, temizle`,
    sirala: 'Sırala',
    sIlk: 'Üyelik tarihi, yeni önce',
    sSon: 'Son görülme, en eski önce',
    kim: 'Kim',
    uyelik: 'Üyelik tarihi',
    gorulme: 'Son görülme',
    eposta: 'E-posta',
    siparis: 'Sipariş',
    bulten: 'Bülten izni',
    crm: 'CRM müşteri kaydı',
    kademe: (n: number | null) => `kademe ${n ?? 0}`,
    kademeTelefon: (n: number | null) => `kademe ${n ?? 0}, telefon var`,
    hicOturum: 'hiç oturum yok',
    bilinmiyor: 'henüz aktarılmadı',
    eslesmeyle: '(e-posta eşleşmesiyle)',
    dogrulandi: 'Doğrulandı',
    dogrulanmadi: 'Doğrulanmadı',
    onayli: 'Onaylı',
    kayitYok: 'Kayıt yok',
    bekliyor: 'Onay bekliyor',
    engelli: 'Engelli',
    abonelikIptal: 'Abonelikten çıktı',
    eslesmeYok: 'Eşleşme yok',
    bagli: (ad: string) => `Bağlı: ${ad}`,
    ayriTutuldu: 'Ayrı tutuldu',
    kararVer: 'Karar ver',
    bos: ['Bu süzgeçte üye yok', 'Süzgeci, aramayı ya da tarih aralığını temizleyin.'],
    not: 'Son görülme sitenin oturum kaydından gelir. Sipariş sayısı e-posta eşleşmesiyle sayılır: üye girişiyle verilen sipariş sayılmaz, siparişin e-postası bir üyeyle aynıysa o üyeye yazılır. Üyelik onayı sitede kaydedilmemişse boş görünür.',
    daha: 'Daha fazla göster',
  },

  // --- kişi sayfası ---
  kisi: {
    geri: 'Üyelere dön',
    yol: (ad: string) => `Web sitesi / Üyeler / ${ad}`,
    dogrulandi: 'E-posta doğrulandı',
    dogrulanmadi: 'E-posta doğrulanmadı',
    bultenOnayli: 'Bülten onaylı',
    bultenYok: 'Bülten kaydı yok',
    bultenBekliyor: 'Bülten onay bekliyor',
    bultenKapali: 'Bülten kapalı',
    crmYok: 'CRM kaydı yok, karar bekliyor',
    crmBagli: (ad: string) => `CRM kaydına bağlı: ${ad}`,
    crmAyri: 'CRM kaydı yok, ayrı tutuldu',
    hicOturum: 'Hiç oturum açmadı',
    siparisSay: 'sipariş (e-posta eşleşmesiyle)',
    odenen: 'ödenen',
    bekliyorIptal: (i: number) => `ödeme bekliyor, ${i} iptal`,
    oturum: 'oturum',
    uyelikTarihi: 'Üyelik tarihi',
    ilkOturum: 'İlk oturum',
    sonGorulme: 'Son görülme',
    telefon: 'Telefon',
    uyelikOnayi: 'Üyelik onayı',
    kademe: 'Kademe',
    yok: 'yok',
    var: 'var',
    kaydedilmemis: 'kaydedilmemiş',
    aktarilmadi: 'henüz aktarılmadı',
    son40: 'Son 40 gün',
    son40Alt: 'Üyelik, oturum ve sipariş tek çizgide. Noktanın üstündeki sayı aynı anda verilen sipariş sayısı.',
    seritUyelik: 'Üyelik',
    seritOturum: 'Oturum',
    seritSiparis: 'Sipariş',
    bugun: 'bugün',
    gunOnceKisa: (n: number) => `${n} g önce`,
    seritAria: (ad: string) => `${ad} etkinlik çizgisi: son 40 gün`,
    lejandUyelik: 'Üyelik ve oturum',
    lejandIptal: 'İptal edilen sipariş',
    lejandBekleyen: 'Ödeme bekleyen sipariş',
    uyeOldu: (an: string) => `Üye oldu: ${an}`,
    dogruladi: (an: string) => `E-posta doğrulandı: ${an}`,
    ilkOturumIpucu: (an: string) => `İlk oturum: ${an}`,
    sonIpucu: (an: string) => `Son görülme: ${an}`,
    siparisIpucu: (n: number, an: string, bekleyen: boolean) => `${n} sipariş, ${an}${bekleyen ? ', biri ödeme bekliyor' : ', hepsi iptal ya da kapalı'}`,
    zaman: 'Zaman çizelgesi',
    zamanAlt: 'Siparişler, talepler ve oturumlar tek çizgide.',
    siparislerdeAc: (n: number) => `Siparişlerde aç (${n})`,
    destekYok: 'Bu e-postayla eşleşen destek talebi yok.',
    crmKart: 'CRM müşteri kaydı',
    crmKartAlt: 'CRM\'de bu üyeyle aynı e-posta ya da ada sahip müşteri bulunamadı. Aynı kişi mi, kendiniz karar verin.',
    crmBagliAlt: 'Bu üye CRM\'deki müşteri kaydıyla ilişkilendirilmiş. Yanlışsa bağı kaldırabilirsiniz.',
    sorun: 'Aynı kişi mi?',
    sorunNot: 'Bağlarsanız kayıtlar birleşmez, yalnız ilişkilendirilir; sonra kaldırılabilir.',
    baglaDugme: 'Başka bir müşteriye bağla',
    ayriTut: 'Müşteri kaydı yok, ayrı tut',
    bagiKaldir: 'Bağı kaldır',
    notEtiket: 'Karar notu (zorunlu)',
    musteriAra: 'CRM müşterisi ara (ad ya da telefon)',
    musteriAraAria: 'CRM müşterisi ara',
    uc: 'Aramak için en az 3 harf yazın.',
    sonucYok: 'Sonuç yok. CRM\'de bu aramayla eşleşen müşteri bulunamadı.',
    baglaSec: 'Bağla',
    kayitEdildi: 'Karar kaydedildi.',
    yetkiYok: 'Karar vermek için bağlama yetkisi gerekir.',
    hukuk: 'Hukuki dayanak',
    hukukMetin: 'Kişisel veri işleme dayanağı: BAE PDPL (2021 tarihli 45 sayılı Federal Kararname-Kanun).',
    sistemEtiketi: 'üye',
  },
  olay: { uye: 'Üyelik', oturum: 'Oturum', sip: 'Sipariş', destek: 'Destek', on: 'Ön talep', vize: 'Vize' },
  olayTumu: 'Tümü',

  // --- siparişler ---
  siparisler: {
    durumBaslik: 'Durum',
    durumAlt: (n: number) => `${n} sipariş. Çubuğa tıklayınca liste o duruma süzülür.`,
    odendiRozet: (n: number) => `${n} ödendi`,
    paraBirimi: (satirlar: string) => `Para birimi: ${satirlar}. Tutarlar toplanmadı, para birimleri karışık.`,
    crmFark: (crm: number, v3: number) => `CRM'de ${crm} sipariş görünüyor, sitede ${v3}, ${v3 - crm} eksik.`,
    baslik: 'Web siparişleri',
    alt: 'Ödeme bekleyen ve eşiği aşanlar en üstte. Rezervasyon bekleyenler: ödemesi alınmış, tedarikçide rezervasyonu yapılacak siparişler.',
    adet: (n: number) => `${n} sipariş`,
    hepsi: 'Tümü',
    bekleyen: 'Ödeme bekliyor',
    rez: 'Rezervasyon bekleyenler',
    geciken: (gun: number) => `${gun} günü geçen`,
    odendi: 'Ödendi',
    iptal: 'İptal',
    kisiSuzgeci: (ad: string) => `${ad} siparişleri, temizle`,
    siparis: 'Sipariş',
    durum: 'Durum',
    tutar: 'Tutar',
    kisi: 'Kişi',
    bekleme: 'Bekleme',
    verildi: 'Verildi',
    bekliyorEtiket: 'Ödeme bekliyor',
    provizyonda: 'Provizyonda',
    iptalEtiket: 'İptal edildi',
    odendiEtiket: 'Ödendi',
    iadeEtiket: 'İade edildi',
    kapandi: 'kapandı',
    misafirOlarak: '(misafir olarak)',
    odenenBos: (n: number) => `Henüz hiçbir siparişin ödemesi alınmadı. ${n} siparişin 0 tanesi ödendi.`,
    odenenBosBaslik: 'Ödenen sipariş yok',
    suzgecBos: ['Bu süzgeçte sipariş yok', 'Süzgeci, aramayı ya da tarih aralığını temizleyin.'],
    rezBaslik: 'Rezervasyon bekleyenler',
    rezAlt: 'Ödemesi alınmış, tedarikçide rezervasyonu yapılacak siparişler. Liste sitenin operasyon kuyruğundan okunur.',
    rezYetki: 'Bu kuyruğu okumak için operasyon okuma yetkisi gerekir.',
    rezSayiYok: 'okunamadı',
    daha: 'Daha fazla göster',
    guncel: 'Durum',
    aria: 'Sipariş durumları',
    ipucu: (etiket: string, n: number) => `${etiket}: ${n} sipariş. Tıklayınca listeyi açar`,
    asamaNotOdemeYok: (n: number) => `Ödeme aşamasında ${n} iş bekliyor, ödeyen yok.`,
    asamaNot: (n: number, odenen: number) => `Ödeme aşamasında ${n} iş bekliyor, ${odenen} ödendi.`,
    asamaAlt: (n: number) => `${n} verildi`,
    asamaBaslik: 'Sipariş',
    uyeDegil: '(üye değil)',
    durumSatir: { hepsi: 'Verildi', bekleyen: 'Ödeme bekliyor', odendi: 'Ödendi', iptal: 'İptal' },
  },

  // --- çekmece ---
  cekmece: {
    kapat: 'Çekmeceyi kapat',
    aria: 'Kişi çekmecesi',
    kisiSayfasi: 'Kişi sayfasını aç',
    zaman: 'Zaman çizelgesi',
    karar: 'Karar',
    bu: 'Bu iş için karar',
    cevaplandi: 'Cevaplandı olarak işaretle',
    ulasildi: 'Ulaşıldı olarak işaretle',
    kapatDugme: 'Kapat',
    operasyonda: 'Operasyonda aç',
    siparisiAc: 'Siparişi aç',
    onTalepNot: 'Ön talep kararı, Satış bölümündeki ön talep listesinde not zorunlu olarak verilir.',
    onTalepAc: 'Ön talepleri aç',
    yetkiYok: 'Bu işlem için yetkiniz yok.',
    yapildi: 'Durum güncellendi.',
    sipNot: 'Bu siparişte işlem yok. Kişi varsa kişi sayfasından bütün geçmişe bakın.',
    referans: 'Referans',
    tur: 'Tür',
    bekleme: 'Bekleme',
    esik: 'Eşik',
    kimde: 'Kimde',
    tutar: 'Tutar',
    durum: 'Durum',
    verildi: 'Verildi',
    odenen: 'Ödenen',
    ziyaretci: (ad: string) => `${ad} (üye değil)`,
    sonraki: 'Sonraki adım',
  },

  // --- destek mesajı: kaynak, yanıt, spam (17.10.2026) ---
  /** Ön talep çekmecesi (19.10.2026): WhatsApp teklifinde kime nasıl ulaşılır. */
  onTalep: {
    baslik: 'İletişim',
    yokNot: "Ziyaretçi iletişim bilgisi bırakmadı; bu teklifle WhatsApp'a yönlendirildi. Mesaj geldiyse WhatsApp Business'ta şu kodu arayın:",
    yokNotKodsuz: 'Ziyaretçi iletişim bilgisi bırakmadı. Bu kayıtta WhatsApp mesajında aranacak bir teklif kodu yok.',
    yokEtiket: 'İletişim yok',
    kodEtiket: 'Aranacak kod',
    kodKopyala: 'Kodu kopyala',
    telefon: 'Telefon',
    whatsappYaz: "WhatsApp'ta yaz",
    ara: 'Ara',
    telKopyala: 'Numarayı kopyala',
    numaraBicimsiz: 'Numara uluslararası biçimde değil: WhatsApp bağlantısı kurulmadı, numarayı kopyalayıp elle girin.',
    kopyalandi: 'Kopyalandı.',
    kopyalanamadi: 'Kopyalanamadı, metni elle seçin.',
    teklifBaslik: 'Teklif',
    kisi: 'Kişi',
    tarih: 'Tarih',
    toplam: 'Toplam',
    yetiskin: (n: number) => `${n} yetişkin`,
    cocuk: (n: number) => `${n} çocuk`,
    bebek: (n: number) => `${n} bebek`,
    kisiSayisi: (n: number) => `${n} kişi`,
    karar: "Ulaşıldı olarak işaretleme kararı aynen duruyor: WhatsApp'ta yazışma başladıysa numarayı ve notu girip işaretleyin.",
  },

  destek: {
    kaynakBaslik: 'Kaynak',
    nereden: 'Nereden geldi',
    akis: {
      'form-ziyaretci': 'Sitedeki destek formu, üye olmayan ziyaretçi',
      'form-uye': 'Sitedeki destek formu, üye girişiyle',
      'hayal-rotasi': 'Hayal rotası formu',
      'tatil-bulucu': 'Tatil bulucu formu',
      'bilet-ctg': 'Bilet tedarikçisi izi (sistem)',
      'esik-bildirimi': 'Operasyon eşik bildirimi (sistem)',
      'periyodik-denetim': 'Periyodik denetim (sistem)',
      sistem: 'Sistem yoklaması',
      bilinmeyen: 'Bilinmeyen akış',
    },
    akisKisa: {
      'form-ziyaretci': 'Destek formu',
      'form-uye': 'Destek formu, üye',
      'hayal-rotasi': 'Hayal rotası',
      'tatil-bulucu': 'Tatil bulucu',
      'bilet-ctg': 'Bilet izi',
      'esik-bildirimi': 'Eşik bildirimi',
      'periyodik-denetim': 'Denetim',
      sistem: 'Sistem',
      bilinmeyen: 'Bilinmeyen akış',
    },
    konu: 'Konu',
    kategoriEtiket: 'Konu grubu',
    kategori: {
      siparis: 'Sipariş ve rezervasyon',
      vize: 'Vize başvurusu',
      odeme: 'Ödeme ve fatura',
      iade: 'İptal ve iade',
      isletme: 'İşletme kaydı',
      grup: 'Grup talebi',
      schengen: 'Schengen vizesi danışmanlığı',
      ingiltere: 'Birleşik Krallık vizesi danışmanlığı',
      abd: 'ABD vizesi danışmanlığı',
      rusya: 'Rusya vizesi danışmanlığı',
      cin: 'Çin vizesi danışmanlığı',
      degisiklik: 'Rezervasyon değişikliği',
      iptal: 'Rezervasyon iptali',
      diger: 'Diğer',
    },
    serbest: 'Serbest metin, formun listesinden değil',
    dilEtiket: 'Yazılan dil',
    dil: { tr: 'Türkçe', en: 'İngilizce' },
    dilNot: 'Site dili CRM\'e gönderilmiyor; dil konudan ve metinden tahmin ediliyor.',
    geldi: 'Geldi',
    gonderen: 'Gönderen e-posta',
    siparisEtiket: 'Sipariş',
    siparisYok: 'sipariş bağlantısı yok',
    siparisiAc: 'Siparişi aç',
    musteriEtiket: 'CRM müşterisi',
    musteriDegil: 'müşteri değil',
    uyeEtiket: 'Site üyesi',
    uyeDegil: 'üye değil',
    sinifEtiket: 'Sınıf',
    sinif: { GERCEK: 'Gerçek', SUPHELI: 'Şüpheli', SPAM: 'Spam' },
    nedenBaslik: 'Neden bu sınıf',
    nedenYok: 'Şüpheli bir işaret bulunmadı.',
    puan: (n: number) => `Toplam puan ${n}`,
    elleSpam: 'Elle spam olarak işaretlendi.',
    elleDegil: 'Elle spam değil olarak işaretlendi.',
    sistemMesaji: 'Bu bir sistem yoklaması, müşteri mesajı değil. Yanıt gerekmez.',
    yanit: {
      baslik: 'Müşteriye dön',
      alt: "CRM e-posta göndermez. Taslak e-posta uygulamanda açılır, gönderimi sen yaparsın. Gönderdikten sonra Cevaplandı olarak işaretle.",
      epostaAc: 'E-posta ile yanıtla',
      adresKopyala: 'Adresi kopyala',
      konuKopyala: 'Konuyu kopyala',
      metinKopyala: 'Metni kopyala',
      kopyalandi: 'Kopyalandı.',
      kopyalanamadi: 'Kopyalanamadı, metni elle seçin.',
      adresGecersiz: 'Gönderen adresi okunamadı, e-posta bağlantısı kapalı. Adresi kopyalayıp elle yazın.',
      taslakBaslik: 'Yanıt taslağı',
      taslakDil: (dil: string) => `Taslak ${dil} hazırlandı.`,
      konuEtiket: 'Yanıt konusu',
      metinEtiket: 'Yanıt metni',
      taslagaDon: 'Taslağa dön',
      taslagaDondu: 'Düzenleme geri alındı, taslak yüklendi.',
      duzenlenebilir: 'Konuyu ve metni burada düzenleyebilirsin. E-posta bağlantısı ve kopyala düğmeleri düzenlenmiş hâli kullanır.',
      uzunNot: 'Metin uzun: bazı e-posta uygulamaları e-posta bağlantısında metni keser. Metni kopyalayıp e-postaya yapıştır.',
    },
    spamKapat: 'Spam olarak kapat',
    spamDegil: 'Spam değil',
  },

} as const;

/** Ay adları değil: bütün tarih biçimleri `web-sitesi-bicim.ts` içinde ve BAE saatiyle. */
export type WsMetin = typeof WS;
